import { render, staticRenderFns } from "./voucherBtn.vue?vue&type=template&id=25d0744a"
import script from "./voucherBtn.vue?vue&type=script&lang=js"
export * from "./voucherBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports